var ResponsiveTabs = function(el) {
  // constructor
  this.el = el
  //this.init()
}

ResponsiveTabs.prototype.init = function() {
  const el = this.el
  this.el.classList.add('responsive-tabs')
  const arrow = document.createElement('span')
  arrow.classList.add('dropdown-arrow')
  this.el.append(arrow)
  this.el.querySelectorAll('.nav-link').forEach(btn => {
    btn.addEventListener('click', function() {
      if (this.classList.contains('active')) {
        el.classList.toggle('open')
      } else {
        el.classList.remove('open')
      }
    })
  })
}

export default ResponsiveTabs
